import React, { useState, useRef } from 'react';
import DrawingOptions from 'components/quote_builder_widget/DrawingOptions';
import { PostRequest } from 'components/common/index.js';

const SUCCESS_DISPLAY_DURATION_MILLISECONDS = 3000;

const QuoteBuilderForm = ({ theme, id, setId, drawing, unitOption = 'both', widgetIdentifier }) => {
  const formRef = useRef(null);
  const [buttonState, setButtonState] = useState('ready');
  const [errorMessage, setErrorMessage] = useState(null);

  const DrawingMaterialChooser = theme.DrawingMaterialChooser;
  const SubmitButton = theme.SubmitButton;

  const handleSubmit = () => {
    const catalogName = drawing?.catalog_name;
    console.log('[QuoteBuilderForm] handleSubmit called', { buttonState, formRef: !!formRef.current, catalogName, drawing });
    if (buttonState !== 'ready' || !formRef.current || !catalogName) {
      console.log('[QuoteBuilderForm] Early return', { buttonStateReady: buttonState === 'ready', hasFormRef: !!formRef.current, hasCatalogName: !!catalogName });
      return;
    }

    setErrorMessage(null);
    setButtonState('submitting');

    const formData = new FormData(formRef.current);
    const entries = Object.fromEntries(formData.entries());

    // Separate drawing options from other form fields
    // drawing.option_names is a string array from the API (e.g., ['a', 'b', 'c'])
    const drawingOptionNames = drawing?.option_names || [];
    const data = {
      drawing_options: {}
    };

    for (const [key, value] of Object.entries(entries)) {
      if (drawingOptionNames.includes(key)) {
        data.drawing_options[key] = value;
      } else if (!key.startsWith('__')) {
        // Skip checkbox helper fields (prefixed with __)
        data[key] = value;
      }
    }

    PostRequest({
      url: `/widget/quote-builder/${widgetIdentifier}/${catalogName}/build-quote`,
      data: data,
      callback: () => {
        setButtonState('success');
        setTimeout(() => {
          setButtonState('ready');
        }, SUCCESS_DISPLAY_DURATION_MILLISECONDS);
      },
      400: (data) => {
        setButtonState('ready');
        if (data.rules && data.rules.length > 0) {
          setErrorMessage(data.rules[0].description);
        } else if (data.error) {
          setErrorMessage(data.error);
        }
      },
      404: (data) => {
        setButtonState('ready');
        if (data.error) {
          setErrorMessage(data.error);
        }
      },
      500: () => {
        setButtonState('ready');
        setErrorMessage('An unexpected error occurred. Please try again.');
      }
    }).catch(() => {
      setButtonState('ready');
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <form ref={formRef} onSubmit={handleFormSubmit}>
      <DrawingOptions
        theme={theme}
        id={id}
        setId={setId}
        drawing={drawing}
        unitOption={unitOption}
      />
      {widgetIdentifier && DrawingMaterialChooser && (
        <DrawingMaterialChooser widgetIdentifier={widgetIdentifier} drawingId={id} />
      )}
      {errorMessage && (
        <div
          data-widget-element="error-message"
          style={{
            color: '#dc3545',
            padding: '8px 12px',
            marginBottom: '12px',
            fontSize: '14px'
          }}
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      )}
      {widgetIdentifier && SubmitButton && (
        <SubmitButton
          buttonState={buttonState}
          onClick={handleSubmit}
        />
      )}
    </form>
  );
};

export default QuoteBuilderForm;
